"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Reference
 * @since 0.1.5
 * @version 0.1.5
 */
exports.reference = new RegExp('^(ZT[\\d]+)-((?:RP|WS|HC|SF|WK|SP)[A-Z][ISX][LRx])(?:-(\\d{2}[A-Z][a-zA-Z]))?-(1[5-9]|[2-7][0-9]|80)+(0[1-9]|[1-4][0-9]|5[0-3])+(\\d{4,5})$');
exports.fakeReference = new RegExp('^ZT0-(RP|WS|HC|SF|WK|SP)[A-Z][ISX][LRx](-\\d{2}[A-Z][a-zA-Z])?-([0-9]{9})$');
/**
 * Reference
 * @since 0.1.5
 * @version 0.1.5
 */
exports.abbr = new RegExp('^\\d{4}\\w{1}\\d{4,5}$');
/**
 * Mac
 * @since 0.1.5
 * @version 0.1.6
 */
exports.mac = new RegExp('^((?:[A-F0-9]{2}[:-]){5}[A-F0-9]{2})$');
/**
 * Shoes size
 * Min 18
 * Max 52
 * @since 0.1.94
 * @version 0.1.94
 */
exports.shoesSize = new RegExp('^(1[89]|[2-4][0-9]|5[0-2])$');
exports.default = {
    reference: exports.reference,
    fakeReference: exports.fakeReference,
    abbr: exports.abbr,
    mac: exports.mac,
    shoesSize: exports.shoesSize,
};
//# sourceMappingURL=soles.js.map